import * as G6 from '@antv/g6';

import { Layer } from 'dashboard/components/GraphCanvasV2/layers/layer';
import SelectionBoxTarget from 'dashboard/components/GraphCanvasV2/target/selection-box-target';

export default class SelectionBoxLayer extends Layer implements Iterable<SelectionBoxTarget> {
  public [Symbol.iterator](): Iterator<SelectionBoxTarget, null> {
    const items: G6.IShape[] = [];
    const selectionBox = this.g6Wrapper.selectionBox;
    if (
      this.canvasX != null &&
      this.canvasY != null &&
      selectionBox != null &&
      !selectionBox.destroyed
    ) {
      const {
        minY: selectionMinY,
        maxY: selectionMaxY,
        minX: selectionMinX,
        maxX: selectionMaxX,
      } = selectionBox.getCanvasBBox();

      if (
        selectionMinX < this.canvasX &&
        selectionMaxX > this.canvasX &&
        selectionMinY < this.canvasY &&
        selectionMaxY > this.canvasY
      ) {
        items.push(this.g6Wrapper.selectionBox);
      }
    }

    return {
      next: function () {
        const value = items.shift();

        const result: IteratorResult<SelectionBoxTarget, null> = value
          ? {
              value: new SelectionBoxTarget(value),
              done: false,
            }
          : {
              value: null,
              done: true,
            };

        return result;
      }.bind(this),
    };
  }
}
